import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NglModule} from 'ng-lightning';

import{ ConfigurableLinkListComponent } from '../configurable_link_list/configurable_link_list.component';

@NgModule({
    imports: [
      CommonModule
    ],
    declarations:[ConfigurableLinkListComponent],
    exports:[ConfigurableLinkListComponent],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
  })

export class ConfigurableLinkListModule { }

